// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--QLS8s","return":"index-module--return--3rMKf","icon":"index-module--icon--39SpN","title":"index-module--title--2Ftyp"};